import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import VueSocialSharing from 'vue-social-sharing'

if (navigator.serviceWorker) {
	// firebase service worker for messaging (push notification)
	navigator.serviceWorker.register('/firebase-messaging-sw.js')
		.then((registration) => {
			Vue.prototype.$messaging.useServiceWorker(registration)
		}).catch(err => {
			console.log(err)
		})
}

// todo
// add and test service worker

Vue.config.productionTip = false

Vue.use(VueSocialSharing);

const app = new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')

export default app;